<template>
  <div class="bullets-steps_hor" :class="{'full-width': isFullWidth}">
    <div 
      class="step"
      v-for="index in (this.totalSteps > 0 ? this.totalSteps-1 : 0)" 
      :key="index"
      :class="{'done': index <= activeStep}"
    >
      <div class="circle-label">
        <span class="circle">{{index}}</span>
        <label>{{stepTitles[index-1]}}</label>
      </div>
      <span 
        class="line"
        :class="{'done': index < activeStep}"
      ></span>
    </div>
    <div 
      class="step"
      :class="{'done': this.totalSteps == this.activeStep}"
    >
      <div class="circle-label">
        <span class="circle">{{this.totalSteps}}</span>
        <label>{{stepTitles[this.totalSteps-1]}}</label>
      </div>
      <span class="circle"></span>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import InputDash from "@/components/base/InputDash.vue";

export default {
  components: {
    BaseIcon, 
    InputDash,
  },
  computed: {
  },
  props: {
    height: String,
    totalSteps: Number,
    stepTitles: Array,
    currentStep: Number,
    hasLabels: Boolean,
    isFullWidth: Boolean,
  },
  data() {
    return{
      activeStep: 1
    }
  },
  methods: {

  },
  mounted() {
    this.activeStep = this.currentStep
  },
  watch: {
    currentStep: function(val) {
      this.activeStep = this.currentStep
    },
  }
};
</script>

<style lang="scss" scoped>  
@import "@/style/base";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";
@import "@/style/components/stepBullets";

.side_box {
  max-height: 690px;
  
  label {
    height: 20px;
  }

  input, span{
    height: 30px;
    margin-bottom: 15px;
  }
}
</style>
